/**
 * Monero block template to mine.
 */
export default class MoneroBlockTemplate {
    constructor(template) {
        Object.assign(this, template);
        if (this.expectedReward !== undefined && typeof this.expectedReward !== "bigint")
            this.expectedReward = BigInt(this.expectedReward);
        if (this.difficulty !== undefined && typeof this.difficulty !== "bigint")
            this.difficulty = BigInt(this.difficulty);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (this.getExpectedReward() !== undefined)
            json.expectedReward = this.getExpectedReward().toString();
        if (this.getDifficulty() !== undefined)
            json.difficulty = this.getDifficulty().toString();
        return json;
    }
    getBlockTemplateBlob() {
        return this.blockTemplateBlob;
    }
    setBlockTemplateBlob(blockTemplateBlob) {
        this.blockTemplateBlob = blockTemplateBlob;
        return this;
    }
    getBlockHashingBlob() {
        return this.blockHashingBlob;
    }
    setBlockHashingBlob(blockHashingBlob) {
        this.blockHashingBlob = blockHashingBlob;
        return this;
    }
    getDifficulty() {
        return this.difficulty;
    }
    setDifficulty(difficulty) {
        this.difficulty = difficulty;
        return this;
    }
    getExpectedReward() {
        return this.expectedReward;
    }
    setExpectedReward(expectedReward) {
        this.expectedReward = expectedReward;
        return this;
    }
    getHeight() {
        return this.height;
    }
    setHeight(height) {
        this.height = height;
        return this;
    }
    getPrevHash() {
        return this.prevId;
    }
    setPrevHash(prevId) {
        this.prevId = prevId;
        return this;
    }
    getReservedOffset() {
        return this.reservedOffset;
    }
    setReservedOffset(reservedOffset) {
        this.reservedOffset = reservedOffset;
        return this;
    }
    getSeedHeight() {
        return this.height;
    }
    setSeedHeight(seedHeight) {
        this.seedHeight = seedHeight;
        return this;
    }
    getSeedHash() {
        return this.seedHash;
    }
    setSeedHash(seedHash) {
        this.seedHash = seedHash;
        return this;
    }
    getNextSeedHash() {
        return this.nextSeedHash;
    }
    setNextSeedHash(nextSeedHash) {
        this.nextSeedHash = nextSeedHash;
        return this;
    }
}
